import React from 'react';

import Advice from './Advice';

const filterAdviceExclusions = (advice) =>{
	return advice.exclusions.filter(excl=> excl.uuid )
}
const filterCveExclusions = (advice, exclusion=null) =>{
	return advice.exclusions.filter(excl=> exclusion ? excl.cve === exclusion.cve : excl.cve )
}

const countAdvisoriesWithAdviceExclusion = (advice, advisories) => {
	const adviceExclusions = filterAdviceExclusions(advice)

	const advisoriesWithSameExclusions = []

	for (const currentAdvice of advisories) {
		if (currentAdvice.id === advice.id) continue
		if (filterAdviceExclusions(currentAdvice).length ){
			advisoriesWithSameExclusions.push(currentAdvice)
		}
	}

	return advisoriesWithSameExclusions.length && adviceExclusions.length
}

const countAdvisoriesWithSameCveExclusion = (advice, advisories) => {
	const adviceExclusions = filterCveExclusions(advice)
	const advisoriesWithSameExclusions = []
	const advisoriesUuids = []
	for (const exclusion of adviceExclusions) {
		for (const currentAdvice of advisories) {
			if (currentAdvice.uuid === advice.uuid) continue
			if (filterCveExclusions(currentAdvice, exclusion).length && !advisoriesUuids.includes(currentAdvice.uuid) ){
				advisoriesWithSameExclusions.push(currentAdvice)
				advisoriesUuids.push(currentAdvice.uuid)
			}
		}
	}
	return advisoriesWithSameExclusions.length
}

const processReportAdvisories = (parentProps, report, otherVersionsCount, parentState, advicesData, onlyExclusions, advisories)=>{
	const {privateMode, isLatest, newMitigations, readonly, isSysAdmin, removeMitigations, projectInfo, setJiraIssue} = parentProps;
	const hasSafeVersion = Object.values(report.safeVersions).filter(version=>version).length
	for (const advice of report.advices){
		const uuid=advice.id;
		const id=(report.dependency.library.name+report.dependency.version+uuid).replace(/[^a-zA-Z0-9-]/g, "-").toLowerCase();

		// if(Object.keys(this.generatedAdvisories).includes(uuid)){
		// 	const CurrentAdvice = this.generateAdvicesList[uuid]
		// 	advisories.push(<CurrentAdvice key={id} id={id}/>)
		// 	continue
		// }

		if(!onlyExclusions && advice.exclusions.length) continue;
		if(onlyExclusions && !advice.exclusions.length) continue;
		if(parentState.showFilters){
			if(!parentState.filters.severity.critical && advice.severity==="CRITICAL") continue
			if(!parentState.filters.severity.high && advice.severity==="HIGH") continue
			if(!parentState.filters.severity.medium && advice.severity==="MEDIUM") continue
			if(!parentState.filters.severity.low && advice.severity==="LOW") continue
			const otherThreatLevels = advice.severity!=="CRITICAL" && advice.severity!=="HIGH" && advice.severity!=="MEDIUM" && advice.severity!=="LOW" && !advice.exclusions.length 
			if(!parentState.filters.severity.others && otherThreatLevels) continue
		}
		

		

		advicesData[id]={
			title:"Exclude - issue:",
			domain:"security", 
			adviceContent:{uuid}, 
			cveContent:{cve: advice.prominentIdentifier},
			libraryContent:{
				library:{name:report.dependency.library.name, language: report.dependency.library.language},
				version: report.dependency.version
			},
			content:{},
			report
		};

		const cves = advice.cvesCount = report.advices.filter(advice=>advice.prominentIdentifier && !advice.prominentIdentifier.startsWith("MET-")).length;
		

		const globalExclusion = { 
			advice: report.advices.length>1,
			cve: cves>1,
			library: otherVersionsCount>0
		}
		if (onlyExclusions){
			const adviceGlobalExclusion = countAdvisoriesWithAdviceExclusion(advice, report.advices)
			const cveGlobalExclusion = countAdvisoriesWithSameCveExclusion(advice, report.advices)
			globalExclusion.advice = adviceGlobalExclusion > 0
			globalExclusion.cve = cveGlobalExclusion > 0
		}
		
		const shouldShow={
			hierarchy: report.hierarchy && report.hierarchy.length,
			learn: parentProps.projectInfo.isExperimental,
			locations: report.locations && report.locations.length,
			actions: privateMode && !readonly && isLatest,
			globalExclusion,
			sysadminPanel: isSysAdmin,
			exclusion: onlyExclusions,
			chaiEnabled: parentState.chai.enabled
		}

		advisories.push(<Advice 
			key={id} id={id}
			uuid={uuid}
			name={report.dependency.library.name+":"+report.dependency.version}
			report={report} advice={advice}
			shouldShow={shouldShow} 
			newMitigations={newMitigations}
			removeMitigations = {removeMitigations}
			advicesData={advicesData}
			hasSecureCodeWarriorFeature={parentProps.hasSecureCodeWarriorFeature}
			hasSafeVersion = {hasSafeVersion}
			jiraInfo = {projectInfo.jira}
			setJiraIssue={ setJiraIssue}
			projectUuid={projectInfo.projectInfo.uuid}
		/>)


	}
}


const processTrusted = (parentProps, report,  advisories) => {
	if(!Object.keys(report).includes("transitiveExclusions") || !report.transitiveExclusions.length) return
	const {removeMitigations} = parentProps;
	const uuid=window.randomUuid();
	const id=(report.dependency.library.name+report.dependency.version+uuid).replace(/[^a-zA-Z0-9-]/g, "-").toLowerCase();

	const shouldShow={
		hierarchy: false,
		learn: false,
		locations: false,
		actions: true,
		globalExclusion: { 
			advice: false,
			cve: false,
			library: false
		},
		sysadminPanel: false,
		exclusion: true
	}
	
	
	const advice = {
		id: uuid,
		description: null,
		library: report.dependency.library,
		exclusions: report.transitiveExclusions,
		links: [],
		severity: "TRUSTED",
		type: "security",
		transitive: true
	}
	advisories.push(<Advice 
		key={id} id={id}
		uuid={uuid}
		name={report.dependency.library.name+":"+report.dependency.version}
		report={report} advice={advice}
		shouldShow={shouldShow} 
		newMitigations={null}
		removeMitigations = {removeMitigations}
		advicesData={null}
		hasSecureCodeWarriorFeature={false}
	/>)
}

const ComponentAdvisories = ({parentProps, report, otherVersionsCount, parentState, advicesData, onlyExclusions})=>{
	const advisories = []
	processReportAdvisories(parentProps, report, otherVersionsCount, parentState, advicesData, onlyExclusions, advisories)
	processTrusted(parentProps, report,  advisories)
	return advisories
}

export default ComponentAdvisories